import axiosInstance from '@/store/axios';
import { rejectErrorApi } from '@/store/helper';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    getFiles({ commit }, params) {
      return axiosInstance.get('/asset-manager/file/index', {
        params,
      })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return result.data.tree;
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    createUploadTask({ dispatch }, data) {
      return axiosInstance.post('/asset-manager/file/copy', data)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return result.data.job;
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    parseMRSS({ dispatch }, data) {
      // mrss_url
      return axiosInstance.post('/import/mrss/mapper/parse', data)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return result.data;
        })
        .catch((error) => Promise.reject(error));
    },
  },
};
